<template>
  <div class="wf_container">
    <template v-if="fetchingWorkflow">
      <div class="header_skeleton">
        <v-skeleton-loader class="skeleton" type="text" />
      </div>
      <div class="body_section">
        <div v-for="value in 4" :key="value" class="status_skeleton">
          <v-skeleton-loader class="skeleton" type="text" />
        </div>
      </div>
    </template>
    <template v-else-if="workflow">
      <div class="header_section">
        <div class="header_title" v-text="workflow.name" />
        <v-text-field
          v-model="filterByContact"
          outlined
          class="header_search"
          :label="'Rechercher par contact'"
          prepend-inner-icon="$mdiMagnify"
          dense
          hide-details
        />
      </div>
      <div v-if="!hideStatus" class="body_section">
        <WorkflowFolderStatus
          v-for="(status, index) in workflow.statuses"
          :key="index"
          :status="status"
          :wf-statuses="workflow.statuses"
          :filter-by-contact="filterByContact"
          @openRelanchMass="handleOpenRelanchMass($event)"
        />
      </div>

      <!-- MODAL SECTION -->
      <WorkflowFolderRelaunchDialog
        v-if="openRelanchMass"
        :status-id="activeStatus.id"
        :wf-statuses="workflow.statuses"
        @reloadStatusFolder="reloadStatusFolder()"
        @close="handleCloseRelanchMass()"
      />
    </template>
  </div>
</template>
<script>
import WorkflowAPI from "@/modules/Admin/Services/workflow.api";
import Workflow from "@/core/Models/Workflow";
import WorkflowFolderStatus from "@/modules/Admin/Components/workflow-folder/WorkflowFolderStatus.vue";
import WorkflowFolderRelaunchDialog from "@/modules/Admin/Components/workflow-folder/WorkflowFolderRelaunchDialog.vue";

export default {
  name: "WorkflowFolder",
  components: {
    WorkflowFolderStatus,
    WorkflowFolderRelaunchDialog,
  },
  props: {
    workflowId: {
      type: String,
      required: true,
    },
    organizationId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      hideStatus: false,
      fetchingWorkflow: true,
      workflow: null,
      activeStatus: null,
      openRelanchMass: false,
      searchInput: null,
      filterByContact: null,
    };
  },
  created() {
    this.fetchWorkflow();
  },
  methods: {
    async fetchWorkflow() {
      this.fetchingWorkflow = true;
      try {
        const res = await WorkflowAPI.getOrganizationWorkflow(
          this.organizationId,
          this.workflowId
        );
        this.workflow = new Workflow(res.data);
        this.setBreadcrumbLabel();
      } catch {
        this.$store.dispatch("snackbar/active", {
          message: this.$t("utils.errorHasHappen"),
          type: "ERROR",
        });
      }
      this.fetchingWorkflow = false;
    },
    setBreadcrumbLabel() {
      this.$route.meta.breadcrumbs[0].label = `${this.workflow.name} `;
    },
    handleOpenRelanchMass(status) {
      this.activeStatus = status;
      this.openRelanchMass = true;
    },
    handleCloseRelanchMass() {
      this.activeStatus = null;
      this.openRelanchMass = false;
    },
    reloadStatusFolder() {
      this.hideStatus = true;
      this.$nextTick(() => {
        this.hideStatus = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.wf_container {
  width: 100%;
  height: 100%;
  .header_section {
    width: 100%;
    padding: 20px;
    border: 0.5px solid #ecebf1;
    background: #fff;
    overflow: hidden;
    margin-bottom: 16px;
    height: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .header_title {
      flex-grow: 2;
      font-weight: 600;
      font-size: 20px;
      line-height: 20px;
      text-transform: capitalize;
    }

    .header_search {
      flex-basis: 100px;
    }
  }
  .body_section {
    width: 100%;
    height: calc(100% - 76px);
    display: flex;
    gap: 16px;
    overflow-y: auto;
  }
  .header_skeleton {
    width: 100%;
    margin-bottom: 16px;
    height: 60px;
  }
  .skeleton {
    height: 100%;
    width: 100%;
    ::v-deep {
      .v-skeleton-loader__bone {
        height: 100%;
      }
    }
  }
  .status_skeleton {
    width: 350px;
    height: 100%;
  }
}
</style>
